<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Dataset</v-card-title>
          <v-card-subtitle v-if="modificationTime">
            Última modificación
            {{ modificationTime | moment("MMMM DD YYYY, HH:mm") }}
          </v-card-subtitle>
          <v-card-text class="py-0">
            <v-form>
              <v-text-field
                v-model="name"
                placeholder="Nombre"
                label="Nombre"
              ></v-text-field>
              <v-text-field
                v-model="description"
                label="Descripción"
              ></v-text-field>
              <v-select
                v-model="dashboard"
                :items="dashboards"
                label="Dashboard"
                clearable
              ></v-select>
              <v-select
                v-model="interval"
                :items="intervals"
                label="Monitorear"
                clearable
              ></v-select>
              <v-checkbox v-model="copraApp" label="CopraApp"></v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="updateDataset"
              class="ma-2 text-capitalize"
            >
              <v-icon size="20" class="mr-1">save</v-icon>
              Actualizar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title> Fuentes </v-card-title>
          <v-card-text>
            <sources-table
              :sources="sources"
              v-on:delete-source="deleteSource"
            ></sources-table>
            <v-row>
              <v-col cols="12" class="d-flex justify-end align-center">
                <v-btn
                  color="secondary"
                  @click="showSourcesModal = true"
                  class="text-capitalize"
                  bottom
                  dark
                  rounded
                  outlined
                >
                  <v-icon size="20" class="mr-1">mdi-plus</v-icon>Fuentes
                </v-btn>
                <v-btn
                  color="secondary"
                  @click="analyzeDataset"
                  class="ma-2 text-capitalize"
                  :disabled="analyzeScheduled"
                  text
                  outlined
                >
                  <v-icon size="20" class="mr-1">play_arrow</v-icon>
                  Analizar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <sources-modal
      key="sources-edit"
      :datasetUid="datasetUid"
      :showModal="showSourcesModal"
      @hide-modal="showSourcesModal = false"
      @add-source="addSource($event)"
    />
  </div>
</template>

<script>
import SourcesTable from "@/components/datasets/SourcesTable.vue";
import SourcesModal from "@/components/datasets/SourcesModal.vue";

export default {
  data() {
    return {
      datasetUid: "",
      name: "",
      description: "",
      modificationTime: undefined,
      dashboard: "",
      dashboards: [],
      interval: "",
      intervals: [
        {
          value: "1h",
          text: "Cada 1 Hora",
        },
        {
          value: "6h",
          text: "Cada 6 Horas",
        },
        {
          value: "1d",
          text: "Diariamente",
        },
        {
          value: "1w",
          text: "Semanalmente",
        },
      ],
      copraApp: false,
      showSourcesModal: false,
      sources: [],
      analyzeScheduled: false,
    };
  },
  components: {
    SourcesTable,
    SourcesModal,
  },
  mounted() {
    this.datasetUid = this.$route.params.datasetUid;
    this.$http.get(`/api/datasets/${this.datasetUid}`).then((response) => {
      this.name = response.data.dataset.name;
      this.modificationTime = response.data.dataset.modificationTime;
      this.description = response.data.dataset.description;
      this.dashboard = response.data.dataset.dashboardId;
      this.interval = response.data.dataset.interval;
      this.copraApp = response.data.dataset.copraApp;
    });
    this.$http
      .get(`/api/datasets/${this.datasetUid}/sources`)
      .then((response) => {
        this.sources = response.data.sources;
      });
    this.$http.get("/api/dashboards").then((response) => {
      console.log(response.data);
      this.dashboards = response.data.dashboards.map((entry) => {
        return {
          value: entry.id,
          text: entry.name,
        };
      });
    });
  },
  methods: {
    updateDataset() {
      this.$http
        .put(`/api/datasets/${this.datasetUid}`, {
          name: this.name,
          description: this.description,
          dashboardId: this.dashboard,
          interval: this.interval,
          appEnabled: this.copraApp,
        })
        .then((response) => {
          console.log(response);
          this.$router.push({ path: "/datasets" });
        });
    },
    addSource(source) {
      this.analyzeScheduled = false;
      this.$http
        .post(`/api/datasets/${this.datasetUid}/sources`, source)
        .then((response) => {
          console.log(response.data);
          this.sources.push(source);
          this.showSourcesModal = false;
        });
    },
    deleteSource(item, index) {
      this.$http
        .delete(`/api/datasets/${this.datasetUid}/sources/${item.id}`)
        .then((response) => {
          console.log(response.data);
          this.$eventBus.$emit(
            "showNotification",
            "Fuente eliminada satisfactoriamente",
            "success"
          );
          this.sources.splice(index, 1);
        });
    },
    analyzeDataset() {
      this.analyzeScheduled = true;
      this.$http
        .post(`/api/datasets/${this.datasetUid}/analyze`, {})
        .then((response) => {
          console.log(response.data);
          this.$eventBus.$emit(
            "showNotification",
            "Análisis programado satisfactoriamente",
            "success"
          );
          setTimeout(() => this.$router.push({ path: "/datasets" }), 1000);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>